const PostseasonPerformanceColumns = [
    {label: 'Player', sortField: 'name', columnClass: 'first-column'},
    {label: 'Championships', sortField: 'championships', columnClass: 'third-column'},
    {label: 'Championship Appearances', sortField: 'championshipAppearances', columnClass: 'third-column'},
    {label: 'Playoff Appearances', sortField: 'playoffAppearances', columnClass: 'second-column'}
];

export default PostseasonPerformanceColumns;